import React from 'react';
import { Button, Toggle } from '@carbon/react';
import { Printer } from '@carbon/react/icons';

import styles from 'theme/features/dashboard/export/export-dashboard-wrapper.module.scss';

const ExportDashboardWrapper = ({ children, isFullExport, onChangeExport }) => (
  <div>
    <header className={styles.header}>
      <Toggle
        id="include-summary"
        labelText="Include Summary"
        hideLabel
        labelA="Include Summary"
        labelB="Include Summary"
        size="sm"
        toggled={isFullExport}
        onToggle={onChangeExport}
        className={styles.toggle}
      />
      <Button
        hasIconOnly
        renderIcon={Printer}
        onClick={() => window.print()}
        iconDescription="Print preview"
        className={styles['print-button']}
        kind="ghost"
        size="sm"
        tooltipPosition="bottom"
      />
    </header>
    <div className={styles.wrapper}>{children}</div>
  </div>
);

export default ExportDashboardWrapper;
